import * as ngCdkOverlay from '@angular/cdk/overlay'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'
import { Store as NavbarStore } from '../../store'

import * as group from './group'

/** File Management browser overlay. */
@ngCore.Component({
  imports: [ds.overlay.attached.Component, group.Component],
  selector: 'atn-file-finder',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.fileMgmt.Feature} */
  public readonly fileMgmtFeature = ngCore.inject(state.fileMgmt.Feature)

  /** @see {@link NavbarStore} */
  public readonly navbarStore = ngCore.inject(NavbarStore)

  /**
   * The element that the overlay is connected to.
   */
  public readonly originSg = ngCore.input.required<
    | ngCdkOverlay.CdkOverlayOrigin
    | ngCdkOverlay.FlexibleConnectedPositionStrategyOrigin
  >({
    alias: 'origin',
  })
}
